export default ( arr, key = 'id' ) => {
  return arr.reduce(( dict, item ) => {
    dict[item[key]] = item;
    return dict;
  }, {});
};
